import React, { useEffect, useState } from 'react';
import {useGetRequestedReportQuery } from '../../store/api/orderProductApi';
import Logo from '../tools/Logo';
import PDFRecievedPurchaseOrderGenerator from '../tools/PDFRecievedPurchaseOrderGenerator';
import PDFPurchaseOrderGeneratorReport from '../tools/PDFPurchaseOrderGeneratorReport';

const AllParchasedOrderReports = () => {

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [genId, setGenId] = useState('');
    const [filteredData, setFilteredData] = useState([]);

    const [orderedProduct, setOrderedProduct] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(30);


    const {
        data: ordered,
        error,
        isLoading
    } = useGetRequestedReportQuery({
        refetchOnMountOrArgChange: false
    });

    useEffect(() => {
        if (ordered) {
            setOrderedProduct(ordered);
        }
    }, [ordered]);



    useEffect(() => {
        console.log(getRequestDate(startDate));
        console.log(startDate);
        
        const filterData = () => {
            let filtered = orderedProduct;

            // Filter by date range
            if (startDate && endDate) {
                filtered = filtered.filter(item => item?.updated >= startDate && item?.updated <= endDate);
            }

            setFilteredData(filtered);
        };
        filterData();
    }, [startDate, endDate, genId, orderedProduct]);




    const getRequestDate = (date) => {
        const [year, month, day] = date.split('-').map(Number);
        const dt = new Date(year, month - 1, day);
        return dt.toDateString();
    };







    if (isLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
                <div className="color-text fs-4">Loading...</div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
                <div className="row">
                    <div className="col-12 opacity-75 bg-light p-4 rounded-3 shadow-md border">
                        <h3 className="text-danger">Opps!!!</h3>
                        <span className="fs-4">
                            <span className="text-danger"> An Error has occurred</span>
                        </span>
                        <div className="fs-5"> The server is shut down 😢</div>
                    </div>
                </div>
            </div>
        );
    }



    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handleItemsPerPageChange = (e) => {
        const newItemsPerPage = parseInt(e.target.value);
        const totalPages = Math.ceil(orderedProduct.length / newItemsPerPage);
        setItemsPerPage(newItemsPerPage);
        setCurrentPage(1); // Reset to first page when changing items per page

        // If the current page is greater than the new total pages, set current page to the last page
        if (currentPage > totalPages) {
            setCurrentPage(totalPages);
        }
    };


    const handleStartDateChange = (e) => {
        setStartDate(e.target.value);
    };

    const handleEndDateChange = (e) => {
        setEndDate(e.target.value);
    };





    return (
        <>

            <div className="block-content">
                <h2 className="content-heading text-uppercase">Purchased Orders Reports</h2>
                <div className="row">
                    <div className="col-md-6 mb-3">
                        <label htmlFor="startDate" className="form-label">Start Date</label>
                        <input style={{ height: '45px' }} type="date" className="form-control" id="startDate" value={startDate} onChange={handleStartDateChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label htmlFor="endDate" className="form-label">End Date</label>
                        <input style={{ height: '45px' }} type="date" className="form-control" id="endDate" value={endDate} onChange={handleEndDateChange} />
                    </div>
                 
                </div>

                <div>
                    <div className="table-responsive position-relative" style={{ overflowX: 'auto' }}>
                        <table class="table mb-5 " style={{ minWidth: '1000px' }}>
                            <thead className='table-secondary'>
                                <tr>
                                    <th scope="col">id</th>
                                    <th scope="col">Name</th>
                                    <th scope="col">Requested Quantity</th>
                                    <th scope="col">Recieved Quantity</th>
                                    <th scope="col">Unit</th>
                                    <th scope="col">Status</th>
                                    <th scope="col">Amount</th>
                                    <th scope="col">Total</th>
                                    <th scope="col">Create At</th>
                                    <th scope="col">Updated At</th>
                                    <th scope="col">
                                        <button title='Download' className='btn bg-success border-0' onClick={() => PDFPurchaseOrderGeneratorReport('Purchase Order Report',startDate, endDate, currentItems)}>
                                            <Logo _width={25} name={'../../../image/icons/download.svg'} _color={'#01574E'} _height={20} _marginLeft={0} />
                                        </button>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {

                                    currentItems.map((data, dataIndex) => {

                                        return <>
                                            <tr>
                                                <td >{data.genId}</td>
                                                <td>{data.name}</td>
                                                <td>{data.requestedQty}</td>
                                                <td>{data.recievedQty}</td>
                                                <td>{data.unit}</td>
                                                <td>
                                                    <span className="text-center fw-bold text-success text-capitalize">
                                                        {data.isArrived}
                                                    </span>
                                                </td>
                                                <td>{`$${(+data.amount || 0).toFixed(2)}`}</td>
                                                <td>{`$${Math.round((data.total || 0) * 100) / 100}`}</td>
                                                <td>{data.created}</td>
                                                <td colSpan="3">{data.updated}</td>
                                            </tr>

                                        </>
                                    })
                                }
                                <tr>
                                        <td colSpan="7" className="text-right"><strong>Total</strong></td>
                                        <td><strong>{`$${currentItems && currentItems.length > 0 && currentItems.reduce((sum, item) => sum + item.total, 0).toFixed(2)}`}</strong></td>
                                        <td colSpan="3"></td> 
                                    </tr>
                            </tbody>
                        </table>


                    </div>
                </div>

                <div className='mt-4'>
                    <ul className="pagination justify-content-end">

                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                            <button className="page-link" onClick={() => handlePageChange(currentPage - 1)}>Previous</button>
                        </li>
                        <li className="page-item disabled">
                            <span className="page-link">{currentPage}</span>
                        </li>
                        <li className={`page-item ${currentItems.length < itemsPerPage ? 'disabled' : ''} ${currentItems.length === orderedProduct.length ? 'disabled' : ''}`}>
                            <button className="page-link" onClick={() => handlePageChange(currentPage + 1)}>Next</button>
                        </li>
                        <li className="page-item mx-2">
                            <select className="form-select p-0 px-5 py-1 rounded-0" value={itemsPerPage} onChange={handleItemsPerPageChange}>
                                <option value="3">3</option>
                                <option value="5">5</option>
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="30">30</option>
                                <option value="50">50</option>
                            </select>
                        </li>
                    </ul>
                </div>
            </div>
        </>
    );
};

export default AllParchasedOrderReports;

